/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TemplateVisibility } from './TemplateVisibility';
import {
    TemplateVisibilityFromJSON,
    TemplateVisibilityFromJSONTyped,
    TemplateVisibilityToJSON,
    TemplateVisibilityToJSONTyped,
} from './TemplateVisibility';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface WidgetTemplateRepresentation
 */
export interface WidgetTemplateRepresentation {
    /**
     * 
     * @type {string}
     * @memberof WidgetTemplateRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetTemplateRepresentation
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetTemplateRepresentation
     */
    preset: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetTemplateRepresentation
     */
    title: string;
    /**
     * 
     * @type {Resolution}
     * @memberof WidgetTemplateRepresentation
     */
    resolution: Resolution;
    /**
     * 
     * @type {string}
     * @memberof WidgetTemplateRepresentation
     */
    intervalName: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetTemplateRepresentation
     */
    intervalFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetTemplateRepresentation
     */
    intervalTo?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetTemplateRepresentation
     */
    metricKeys: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WidgetTemplateRepresentation
     */
    category: string;
    /**
     * 
     * @type {TemplateVisibility}
     * @memberof WidgetTemplateRepresentation
     */
    visibility?: TemplateVisibility;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetTemplateRepresentation
     */
    requiredLicenseFeatures?: Array<string>;
}



/**
 * Check if a given object implements the WidgetTemplateRepresentation interface.
 */
export function instanceOfWidgetTemplateRepresentation(value: object): value is WidgetTemplateRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('preset' in value) || value['preset'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    if (!('intervalName' in value) || value['intervalName'] === undefined) return false;
    if (!('metricKeys' in value) || value['metricKeys'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function WidgetTemplateRepresentationFromJSON(json: any): WidgetTemplateRepresentation {
    return WidgetTemplateRepresentationFromJSONTyped(json, false);
}

export function WidgetTemplateRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetTemplateRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'type': json['type'],
        'preset': json['preset'],
        'title': json['title'],
        'resolution': ResolutionFromJSON(json['resolution']),
        'intervalName': json['intervalName'],
        'intervalFrom': json['intervalFrom'] == null ? undefined : json['intervalFrom'],
        'intervalTo': json['intervalTo'] == null ? undefined : json['intervalTo'],
        'metricKeys': json['metricKeys'],
        'category': json['category'],
        'visibility': json['visibility'] == null ? undefined : TemplateVisibilityFromJSON(json['visibility']),
        'requiredLicenseFeatures': json['requiredLicenseFeatures'] == null ? undefined : json['requiredLicenseFeatures'],
    };
}

export function WidgetTemplateRepresentationToJSON(json: any): WidgetTemplateRepresentation {
    return WidgetTemplateRepresentationToJSONTyped(json, false);
}

export function WidgetTemplateRepresentationToJSONTyped(value?: WidgetTemplateRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'type': value['type'],
        'preset': value['preset'],
        'title': value['title'],
        'resolution': ResolutionToJSON(value['resolution']),
        'intervalName': value['intervalName'],
        'intervalFrom': value['intervalFrom'],
        'intervalTo': value['intervalTo'],
        'metricKeys': value['metricKeys'],
        'category': value['category'],
        'visibility': TemplateVisibilityToJSON(value['visibility']),
        'requiredLicenseFeatures': value['requiredLicenseFeatures'],
    };
}

